import { errorString, Encoders, sendJson } from "../../../Bfs.Web.Portale/./Http.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { union_type, string_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { empty, append, singleton } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromString } from "../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../fable_modules/fable-library-js.4.19.0/Util.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { BoolResult_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { Account_ResetPassword_$reflection, Account_ResetPassword } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { ResetPasswordModel__get_CanSubmit, ResetPasswordModel, LostPasswordModel__get_CanSubmit, LostPasswordModel, LostPasswordModel_Init, MessageModel_Init_Z721C83C5, Msg, Model, ResetPasswordModel_Init_Z721C83C5 } from "./Types.fs.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { update } from "../../../Bfs.Web.Portale/Validation.fs.js";
import { errorCmd, request } from "../../../Bfs.Web.Portale/Http.fs.js";

export function Http_postRequestReset(email) {
    const response = sendJson("/api/account/password/requestreset", toString(0, Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(email)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getIsTokenOk(token) {
    let arg;
    const response = fetch((arg = encodeURIComponent(token), toText(printf("/api/account/password/istokenvalid?token=%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(BoolResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postResetPassword(token, password, password2) {
    const body = new Account_ResetPassword(token, password, password2);
    const response = sendJson("/api/account/password/reset", toString(0, Auto_generateBoxedEncoder_437914C6(Account_ResetPassword_$reflection(), undefined, undefined, undefined)(body)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]]), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    switch (page.tag) {
        case 1: {
            const token = page.fields[0];
            return [new Model(1, [ResetPasswordModel_Init_Z721C83C5(token)]), singleton((dispatch) => {
                dispatch(new Msg(3, [token]));
            })];
        }
        case 2:
            return [new Model(2, [MessageModel_Init_Z721C83C5(page.fields[0])]), Cmd_none()];
        default:
            return [new Model(0, [LostPasswordModel_Init()]), Cmd_none()];
    }
}

export function State_updateLostPassword(msg, model) {
    let matchResult, value, text, e;
    switch (msg.tag) {
        case 5: {
            matchResult = 1;
            break;
        }
        case 8: {
            matchResult = 4;
            break;
        }
        case 1:
        case 2:
        case 3:
        case 7:
        case 4: {
            matchResult = 5;
            break;
        }
        case 6: {
            if (msg.fields[0].tag === 1) {
                matchResult = 3;
                e = msg.fields[0].fields[0];
            }
            else {
                const copyOfStruct = msg.fields[0].fields[0];
                if (copyOfStruct.tag === 1) {
                    matchResult = 2;
                    text = copyOfStruct.fields[0];
                }
                else {
                    matchResult = 2;
                    text = copyOfStruct.fields[0];
                }
            }
            break;
        }
        default: {
            matchResult = 0;
            value = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return [new LostPasswordModel(update(model.Email, value), model.Sending, model.IsFinished), Cmd_none()];
        case 1:
            if (LostPasswordModel__get_CanSubmit(model)) {
                return [new LostPasswordModel(model.Email, true, model.IsFinished), request(Http_postRequestReset, model.Email.Value, (Item) => (new Msg(6, [Item])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 2:
            return [new LostPasswordModel(model.Email, false, model.IsFinished), singleton((dispatch) => {
                dispatch(new Msg(7, [text]));
            })];
        case 3:
            return [new LostPasswordModel(model.Email, false, model.IsFinished), errorCmd((Item_1) => (new Msg(8, [Item_1])), "Senden", e)];
        case 4:
            return [model, Cmd_none()];
        default:
            return [model, Cmd_none()];
    }
}

export function State_updateResetPassword(msg, model) {
    let matchResult, value, value_1, token, isTokenOk, e, text_1, text_2, e_1;
    switch (msg.tag) {
        case 5: {
            matchResult = 5;
            break;
        }
        case 8: {
            matchResult = 9;
            break;
        }
        case 0:
        case 7: {
            matchResult = 10;
            break;
        }
        case 2: {
            matchResult = 1;
            value_1 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 2;
            token = msg.fields[0];
            break;
        }
        case 4: {
            if (msg.fields[0].tag === 1) {
                matchResult = 4;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 3;
                isTokenOk = msg.fields[0].fields[0];
            }
            break;
        }
        case 6: {
            if (msg.fields[0].tag === 1) {
                matchResult = 8;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                const copyOfStruct = msg.fields[0].fields[0];
                if (copyOfStruct.tag === 1) {
                    matchResult = 7;
                    text_2 = copyOfStruct.fields[0];
                }
                else {
                    matchResult = 6;
                    text_1 = copyOfStruct.fields[0];
                }
            }
            break;
        }
        default: {
            matchResult = 0;
            value = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return [new ResetPasswordModel(update(model.Password, value), model.Password2, model.Token, model.Message, model.Sending, model.IsFinished), Cmd_none()];
        case 1:
            return [new ResetPasswordModel(model.Password, update(model.Password2, value_1), model.Token, model.Message, model.Sending, model.IsFinished), Cmd_none()];
        case 2:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, true, model.IsFinished), request(Http_getIsTokenOk, token, (Item) => (new Msg(4, [Item])))];
        case 3:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, false, model.IsFinished), isTokenOk.Value ? Cmd_none() : singleton((dispatch) => {
                dispatch(new Msg(7, ["Die angegebenen URL ist nicht mehr gültig."]));
            })];
        case 4:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, false, model.IsFinished), errorCmd((Item_1) => (new Msg(8, [Item_1])), "Senden", e)];
        case 5:
            if (ResetPasswordModel__get_CanSubmit(model)) {
                return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, true, model.IsFinished), request((tupledArg) => Http_postResetPassword(tupledArg[0], tupledArg[1], tupledArg[2]), [model.Token, model.Password.Value, model.Password2.Value], (Item_2) => (new Msg(6, [Item_2])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 6:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, false, model.IsFinished), singleton((dispatch_1) => {
                dispatch_1(new Msg(7, [text_1]));
            })];
        case 7:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, text_2, false, model.IsFinished), Cmd_none()];
        case 8:
            return [new ResetPasswordModel(model.Password, model.Password2, model.Token, model.Message, false, model.IsFinished), errorCmd((Item_3) => (new Msg(8, [Item_3])), "Senden", e_1)];
        case 9:
            return [model, Cmd_none()];
        default:
            return [model, Cmd_none()];
    }
}

export function State_update(msg, model) {
    if (msg.tag === 7) {
        return [new Model(2, [MessageModel_Init_Z721C83C5(msg.fields[0])]), Cmd_none()];
    }
    else {
        switch (model.tag) {
            case 1: {
                const patternInput_1 = State_updateResetPassword(msg, model.fields[0]);
                return [new Model(1, [patternInput_1[0]]), patternInput_1[1]];
            }
            case 2:
                return [model, Cmd_none()];
            default: {
                const patternInput = State_updateLostPassword(msg, model.fields[0]);
                return [new Model(0, [patternInput[0]]), patternInput[1]];
            }
        }
    }
}

//# sourceMappingURL=State.fs.js.map
